import Investors from '@/components/investors/Investors'
import InvestorDetail from '@/components/investors/InvestorDetail'
import InvestorCreate from '@/components/investors/InvestorCreate'
import InvestorUpdate from '@/components/investors/InvestorUpdate'
import BankDataCreate from '@/components/investors/bank-data/BankDataCreate'
import ContactCreate from '@/components/investors/contacts/ContactCreate'
import ContactUpdate from '@/components/investors/contacts/ContactUpdate'
import BankDataUpdate from '@/components/investors/bank-data/BankDataUpdate'

const investorsRoutes = [
  { path: '/investors', name: 'investors', component: Investors },
  { path: '/investor/create', name: 'investor_create', component: InvestorCreate },
  { path: '/investor/update/:id', name: 'investor_update', component: InvestorUpdate },
  { path: '/investor/:id', name: 'investor', component: InvestorDetail },
  // Nested routes
  { path: '/investor/:investor_id/bank-data/create', name: 'investor_bank_data_create', component: BankDataCreate },
  { path: '/investor/:investor_id/contact/create', name: 'investor_contact_create', component: ContactCreate },
  { path: '/investor/:investor_id/contact/update/:contact_id', name: 'investor_contact_edit', component: ContactUpdate },
  { path: '/investor/:investor_id/bank-data/update/:bank_id', name: 'investor_bank_data_edit', component: BankDataUpdate }
]

export default investorsRoutes



// WEBPACK FOOTER //
// ./src/router/investors_routes.js